// extracted by mini-css-extract-plugin
export default {"group_container":"CardContainer_group_container__v-Z3O","card_row":"CardContainer_card_row__Z9oyx"};